import { z } from 'zod'

export const ocrFileSchema = z
  .file('必须上传文件')
  .min(1, '上传文件不能为空')
  .max(10 * 1024 * 1024, '上传文件不能超过 10 MiB')
  .mime(['image/jpeg', 'image/png', 'image/bmp'], '仅支持 JPEG、PNG 或 BMP 图片')

export const ocrUploadSchema: z.ZodType<File, FormData> = z
  .instanceof(FormData)
  .transform((formData) => formData.get('file'))
  .pipe(ocrFileSchema)

export const businessLicenseOcrResultSchema = z.object({
  name: z.string().nullable(),
  unifiedSocialCreditCode: z.string().nullable(),
  legalRepresentative: z.string().nullable(),
  registeredAddress: z.string().nullable(),
  companyType: z.string().nullable(),
  registeredCapital: z.string().nullable(),
  establishedOn: z.string().nullable(),
  validUntil: z.string().nullable(),
  isLongTerm: z.boolean(),
  businessScope: z.string().nullable()
})

export const idCardOcrResultSchema = z
  .object({
    name: z.string().nullable().optional(),
    idNumber: z.string().nullable().optional(),
    gender: z.string().nullable().optional(),
    nation: z.string().nullable().optional(),
    birthday: z.string().nullable().optional(),
    address: z.string().nullable().optional(),
    issuer: z.string().nullable().optional(),
    validPeriod: z.string().nullable().optional()
  })
  .catchall(z.unknown())

export type BusinessLicenseOcrResult = z.infer<typeof businessLicenseOcrResultSchema>

type RentalOcrUpload = {
  file: File
  fileId: number
  kind: 'company' | 'identity'
  force: boolean
}

export const rentalOcrUploadSchema: z.ZodType<RentalOcrUpload, FormData> = z
  .instanceof(FormData)
  .transform((data) => ({
    file: data.get('file'),
    fileId: Number(data.get('fileId')),
    kind: data.get('kind'),
    force: data.get('force') === 'true'
  }))
  .pipe(
    z.object({
      file: ocrFileSchema,
      fileId: z.number().int().positive(),
      kind: z.enum(['company', 'identity']),
      force: z.boolean()
    })
  )

export const rentalOcrResultSchema = z.object({
  recordId: z.number().int().positive().nullable(),
  reused: z.boolean(),
  warning: z.string().optional(),
  result: z.union([businessLicenseOcrResultSchema, idCardOcrResultSchema])
})
